class CookieHandler {
    checkCookie(name: string) {
        return document.cookie.indexOf(name) >= 0;
    }

    setCookie(name: string, value: string, expiryDays: number) {
        const d = new Date();
        d.setTime(d.getTime() + expiryDays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    getCookie(cname: string) {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    deleteCookie(cname: string) {
        document.cookie = cname + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
}
export default CookieHandler;
